export default "__VITE_ASSET__BvXdX2Iz__"